import { render, staticRenderFns } from "./PollVote.vue?vue&type=template&id=255c8b00&scoped=true"
import script from "./PollVote.vue?vue&type=script&lang=js"
export * from "./PollVote.vue?vue&type=script&lang=js"
import style0 from "./PollVote.vue?vue&type=style&index=0&id=255c8b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255c8b00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MyFormulateCheckbox: require('/skade-pwa/components/ui/atom/vueFormulateCustoms/MyFormulateCheckbox.vue').default,Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default})
